import moment from "moment";
export default function DateFormat(value: Date, format?:string): string {
  if(!value)
    return 'Нет';
  if(!format)
    format = "DD.MM.YYYY HH:mm:ss.SSS"
  return moment(value).format(format);
}
